import { Asterisk } from "lucide-react";
import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {t.marquee.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-display text-3xl sm:text-5xl px-6 sm:px-10 whitespace-nowrap ${i % 2 ? "italic text-banana" : "text-paper"}`}>{w}</span>
          <Asterisk className="text-flamingo" size={28} />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className="relative bg-jungle py-6 sm:py-8 overflow-hidden -rotate-1 scale-[1.02] border-y-4 border-mango">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};
